import styled from 'styled-components';

import {
  Divider as SemanticDivider,
  Image as SemanticImage,
} from 'semantic-ui-react';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 25px;
  padding: 0 15px;
`;

const HeaderContent = styled.div`
  display: flex;
  height: 25px;
  margin: 0 20px;
  font-size: 18px;
  font-weight: 400;
`;

const TopicScreener = styled(TextLayoutComponent.Label)`
  flex: 1;
  text-align: left;
  font-size: 16px;
`;

const TopicAnswer = styled(TopicScreener)`
  flex: 1;
`;

const Divider = styled(SemanticDivider)`
  &&&& {
    border-top: 2px solid #EDEDED;
    margin: 0 20px 8px 20px;
  }
`;

const Content = styled.div`
  display: flex;
  font-size: 14px;
  font-weight: normal;
  margin: 0px 20px 0px 20px;
`;

// Question.
const QuestionContainer = styled.div`
  flex: 1;
  flex-direction: row;
  align-items: flex-start;
`;

const Question = styled(TextLayoutComponent.Bold)`
  flex: 1;
  word-wrap: break-word;
  text-align: left;
  font-size: 16px;
`;

// Question Options.
const QuestionOptions = styled(TextLayoutComponent)`
  width: 100%;
  word-wrap: break-word;
  font-size: 14px;
  margin-bottom: 0px;
  text-align: left;
`;

// Answer
const AnswerContainer = styled.div`
  flex: 1;
  flex-direction: row;
  align-items: flex-start;
`;

const Answer = styled.p`
  width: 100%;
  word-wrap: break-word;
  font-size: 14px;
  margin-bottom: 0px;
  text-align: left;
`;

const ErrorMessage = styled(TextLayoutComponent)`
  display: flex;
  padding: 1px 30px;
  margin-bottom: 25px !important;
  text-align: left;
`;

const Title = styled(TextLayoutComponent.Header)`
  margin-bottom: 25px;
  padding: 0 34px;
  font-size: 20px;
`;

export const FooterContent = styled.div`
  padding: 15px 20px 10px;
  text-align: left
`;

export const ScreenerInfo = styled.span`
  font-weight: 500;
`;

const Image = styled(SemanticImage)`
  width: 120px;
`;

const UserInterviewsMessage = styled(TextLayoutComponent.Bold)`
  display: flex;
  margin-top: 15px;
  margin-left: 20px;
  align-items: center;
  gap: 1em;
  line-height: 0;
  text-align: left;
  flex-wrap: wrap;
`;

export {
  Answer,
  AnswerContainer,
  Container,
  Content,
  Divider,
  ErrorMessage,
  HeaderContent,
  Question,
  QuestionContainer,
  QuestionOptions,
  Title,
  TopicAnswer,
  TopicScreener,
  Image,
  UserInterviewsMessage,
};
